import React, { useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { basedAxios } from '../../store/Store';
import EventLabel from '../../components/EventLabel/EventLabel';

interface PaymentDetailsProps {
  orders: any;
  environment: any;
  activePersonNo: number;
}

const PaymentDetails = ({ orders, environment, activePersonNo }: PaymentDetailsProps) => {
  const [paymentDetails, setPaymentDetails] = useState('');

  useEffect(() => {
    (async () => {
      const response = await basedAxios.put(`./tag/tagreplace`, {
        text: '[payments]',
        orderId: toJS(orders)?.[activePersonNo]?.orderId ?? 0,
        eventId: environment.eventId,
        lang: environment.lang,
      });
      setPaymentDetails(response.data.text);
    })();
  }, [orders, activePersonNo, environment]);

  return (
    <>
      <label className="details-title" style={{ textAlign: 'left', width: '100%' }}>
        <EventLabel name={'Payment'} groupName={'Content.StaticLabels'} />
      </label>
      <div className="detail-list [&>div>table>tbody>tr>td]:py-1.5 mt-2 rounded-md" dangerouslySetInnerHTML={{ __html: paymentDetails }} />
    </>
  );
};


export default PaymentDetails;